import React, { useEffect, useState } from 'react';
import { Card, Button, Modal, InputGroup} from 'react-bootstrap';

import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import '../../../Assets/Dripicons/webfont/webfont.css';

import 'react-toastify/dist/ReactToastify.css';
import './Deals.scss';
import Field from '../../Shared/Wizard/Field/Field';
import PageTable from '../../Shared/PageTable/PageTable';

function Deals(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;


    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [allResources, setAllResources] = useState<Array<Object>>([]);
    const [allResourceTypes, setAllResourceTypes] = useState<Array<Object>>([]);
    const [allDeals, setAllDeals] = useState<Array<Object>>([]);

    const [editDeal, setEditDeal] = useState<Object>({});
    const [deleteDeal, setDeleteDeal] = useState("");

    const [showNewModal, setShowNewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showChangeDefaultModal, setShowChangeDefaultModal] = useState(false);

    const [isDefaultDeal, setIsDefaultDeal] = useState(false);
    const [nonDefaultDeal, setNonDefaultDeal] = useState(false);

    const [newDealName, setNewDealName] = useState("");
    const [newDealDescription, setNewDealDescription] = useState("");
    const [newPriceList, setNewPriceList] = useState<Array<Object>>([]);
    const [newDefaultDeal, setNewDefaultDeal] = useState(false);

    const setEditDealName = value => { setEditDeal(editDeal => ({...editDeal, name: value}));}
    const setEditDealDescription = value => { setEditDeal(editDeal => ({...editDeal, description: value}));}
    const setEditDefaultDeal = value => { setEditDeal(editDeal => ({...editDeal, isDefaultDeal: value}));}

    const [updateTable, setUpdateTable] = useState(0);

    const handleCloseNewModal = () => {
        setShowNewModal(false);
        setIsDefaultDeal(false);
        resetForm();
    };

    const handleShowNewModal = () => {
        setShowNewModal(true);
        setIsDefaultDeal(false);
        resetForm();
    };

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDeleteDeal(dataLine);
        setShowDeleteModal(true);
    };

    const handleOpenDeal = (dataLine)=> {
        setEditDeal(dataLine);
        setShowEditModal(true);
    }
    const resetForm = () => {
        setNewDealName("");
        setNewDealDescription("");
        setNewDefaultDeal(false);
        setNewPriceList([]);
        setEditDeal([]);
    }

    const addPriceList = () => {
        setNewPriceList([...newPriceList != undefined ? newPriceList : [], {resource: "", resourceType: "", resourceSubType: "", unit:"", price:""}]);
    }

    const deletePriceList = (key) => {
        let temp = newPriceList;
        temp.splice(key, 1);
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeNewResourceType= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["resourceType"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
     }

    const handleOnChangeNewResourceSubtype= (val,key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["resourceSubtype"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeNewUnit= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["unit"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeNewResource= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["resource"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const setNewPrice= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["price"] = val;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    // edit deal
    const addEditPriceList = () => {
        let temp = editDeal;
        temp["priceList"].push({ resource: "", resourceType: "", resourceSubtype: "", unit:"", price:"" });
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const deleteEditPriceList = (key) => {
        let temp = editDeal;
        temp["priceList"].splice(key, 1);
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeEditResourceType= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["resourceType"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
     }

    const handleOnChangeEditResourceSubtype= (val,key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["resourceSubtype"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeEditUnit= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["unit"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeEditResource= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["resource"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const setEditPrice= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["price"] = val;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }
    
    const handleCreateNewDeal = () => {
        if (newDealName == "") { notifyWarning(t("deals.toast_empty_name")); return undefined; }
        axios.post('/api/deals/', {
            name: newDealName,
            description: newDealDescription,
            isDefaultDeal: newDefaultDeal,
            priceList: newPriceList,
        }
        ,{
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            if(nonDefaultDeal != undefined){
                axios.put('/api/deals/resetDefaultDeal/' + nonDefaultDeal["_id"], {
                    //isDefaultDeal: false,
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                })
            }
            setUpdateTable(updateTable + 1);
            notifySuccess(t("deals.toast_created"));
            setShowNewModal(false);
            fetchData();
            resetForm();
        });
    };

    const handleEditDeal = () => {
        if (editDeal["name"] == "") { notifyWarning(t("deals.toast_empty_name")); return undefined; }

        axios.put('/api/deals/' + editDeal["_id"], {
            name: editDeal["name"],
            description: editDeal["description"],
            isDefaultDeal: editDeal["isDefaultDeal"],
            priceList: editDeal["priceList"],
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            if(nonDefaultDeal != undefined){
                axios.put('/api/deals/resetDefaultDeal/' + nonDefaultDeal["_id"], {
                    //isDefaultDeal: false,
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                })
            }
            setUpdateTable(updateTable + 1);
            setShowEditModal(false);
            notifySuccess(t("deals.toast_updated"));
            fetchData();
        });
    };

    const handleDeleteDeal = () => {
        axios.delete('/api/deals/' + deleteDeal["_id"], {
            id: deleteDeal["_id"]
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            fetchData();
            setShowDeleteModal(false);
            notifySuccess(t("deals.toast_deleted"));
            setUpdateTable(updateTable + 1);
        });
    };

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resourcetypes",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/deals",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setAllResourceTypes(res[0]["data"]);
            setAllResources(res[1]["data"]);
            setAllDeals(res[2]["data"]);

        }))
        .catch(err => console.log(err));
    }
    
    const handleChangeDefaultDeal = () => {
        let foundDefaultDeal:any = allDeals.find(deal => deal["isDefaultDeal"] != undefined ? deal["isDefaultDeal"] != false : null);
    
        if( Object.keys(editDeal).length !== 0 && editDeal["isDefaultDeal"] != true ) {
            setEditDefaultDeal(true);
        } else if(newDefaultDeal != true){
            setNewDefaultDeal(true);
        }

        if(foundDefaultDeal != undefined) setNonDefaultDeal(foundDefaultDeal);
        setShowChangeDefaultModal(false);
        setIsDefaultDeal(true);
    }

    const handleIsDefaultDealExit = (evt) => {
        let foundDefaultDeal:any = allDeals.find(deal => deal["isDefaultDeal"] != undefined ? deal["isDefaultDeal"] != false : null);
     
        if(foundDefaultDeal != undefined) { //reset default deal to non default deal.
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            setShowChangeDefaultModal(true);
        } else handleChangeDefaultDeal();


    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="maincontent">
            <div className="myaccount-container">
                <div className="pagetitle-container">
                    <h1>{t("deals.page_name")}</h1>
                </div>
                <Card>
                    <Card.Body>
                        <h3>{t("deals.title")}</h3>
                        <Button className="newDealBtn" onClick={(handleShowNewModal)}>{t("deals.new")}</Button>
                        <PageTable
                            dataUrl={"/api/deals/getAllPaged"}
                            options={{
                                pageSize: 10,
                                showFields: [
                                    //{ label: t("deals.name"), field: "name" },
                                    { label: t("deals.name"), field: "name", override: dataLine => dataLine["isDefaultDeal"] == true ? <span><i className="dripicons-star" /> {dataLine["name"]}</span> :  dataLine["name"]}, 
                                    { label: t("deals.description"), field: "description" },
                                    { label: t("deals.totaldeals"), field: "priceList", override: (dataline) => dataline["priceList"]!= undefined ? dataline["priceList"].length : ""},
                                ]
                            }}
                            exclusiveFilters={null}
                            loadingText={t("deals.loading")}
                            updateTable={updateTable}
                            dataAfter={(dataLine) => <Button onClick ={(evt) => handleShowDeleteModal(dataLine, evt)}> {t("deals.delete")} </Button>}
                            onLineClick={dataLine => dataLine["accessRule"] != "adminprivate" ? handleOpenDeal(dataLine) : null }
                            hover={true}
                            hoverExempt={dataLine => dataLine["accessRule"] == "adminprivate"}
                            hidePagination={false}
                            hideFilter={false}
                            defaultSortField="name"
                            defaultSortDirection="desc"
                        ></PageTable>
                    </Card.Body>
                </Card>
                <Modal show={showNewModal} size="xl" onHide={handleCloseNewModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("deals.title_new")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Field
                            type="input"
                            title={t("deals.name")}
                            value={newDealName}
                            onChange={value => setNewDealName(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={t("deals.description")}
                            value={newDealDescription}
                            onChange={value => setNewDealDescription(value)}
                        ></Field>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("deals.isdeault")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Button disabled={isDefaultDeal} onClick={(evt) => handleIsDefaultDealExit(evt)} >
                                {t("deals.btn_default")}
                            </Button>
                        </InputGroup> 
                        <hr/>
                        <h3>{t("deals.pricelist")}</h3>
                        <div>
                            <table className="pricelisttable">
                                <thead>
                                    <tr>
                                        <th>{t("deals.resource_type")}</th>
                                        <th>{t("deals.resource_subtype")}</th>
                                        <th>{t("deals.unit")}</th>
                                        <th>{t("deals.resource")}</th>
                                        <th>{t("deals.price")}</th>
                                        <th>{t("deals.delete")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newPriceList != undefined ? newPriceList.map((item, key) => 
                                        <tr key={key}>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.resource_type")}
                                                    value={{value: item["resourceType"], label: item["resourceType"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeNewResourceType(val, key)
                                                    }}
                                                    options={{
                                                        choosetext: t("deals.resource_type_choosetext"),
                                                        choices: allResourceTypes!= undefined ? allResourceTypes.map(i => { return { label: i["name"], value: i["_id"] } }) : null

                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.resource_subtype")}
                                                    value={item["resourceSubtype"]}
                                                    onChange={(val) => {
                                                        handleOnChangeNewResourceSubtype(val, key)
                                                    }}
                                                    options={{
                                                        choosetext: t("deals.resource_subtype_choosetext"),
                                                        choices: allResourceTypes!= undefined ? ((allResourceTypes.find(i => i["_id"] == item["resourceType"]) || {})["resourceSubtype"] || []).map(i => { return { label: i, value: i } }) : [] 
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.unit")}
                                                    value={{value: item["unit"], label: item["unit"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeNewUnit(val, key)
                                                    }}
                                                    options={{
                                                    choosetext: t("deals.type_choosetext"),
                                                        choices: [
                                                            { label: "day", value: "day" },
                                                            { label: "week", value: "week" },
                                                            { label: "month", value: "month" },
                                                            { label: "hour", value: "hour" },
                                                            { label: "once", value: "once" }
                                                        ]
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.resrouce")}
                                                    value={{value: item["resource"], label: item["resource"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeNewResource(val, key)
                                                    }}
                                                    options={{
                                                        choosetext: t("deals.resource_choosetext"),
                                                        choices: allResources!= undefined ? (allResources.filter(i => i["resourceSubtype"] == newPriceList[key]["resourceSubtype"] )).map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="input"
                                                    //title={t("deals.price")}
                                                    value={item["price"]}
                                                    onChange={(val) => {
                                                        setNewPrice(val, key)
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <InputGroup.Append>
                                                    <Button onClick={(evt) => deletePriceList(key)}>{t("deals.pricelist_delete")}</Button>
                                                </InputGroup.Append>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            <Button onClick={addPriceList}>{t("deals.pricelist_add")}</Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCloseNewModal}>
                            {t("deals.cancel")}
                        </Button>
                        <Button onClick={handleCreateNewDeal}>
                            {t("deals.save")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal size="xl" show={showEditModal} onHide={() => setShowEditModal(false)} >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("deals.edit")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Field
                            type="input"
                            title={t("deals.name")}
                            value={editDeal["name"]}
                            onChange={value => setEditDealName(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={t("deals.description")}
                            value={editDeal["description"]}
                            onChange={value => setEditDealDescription(value)}
                        ></Field>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("deals.isdeault")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Button disabled={editDeal["isDefaultDeal"] != true ? false : true} onClick={(evt) => handleIsDefaultDealExit(evt)}>
                                {t("deals.btn_default")}
                            </Button>
                        </InputGroup> 
                        <hr/>
                        <div>
                            <table className="pricelisttable">
                                <thead>
                                    <tr>
                                        <th>{t("deals.resource_type")}</th>
                                        <th>{t("deals.resource_subtype")}</th>
                                        <th>{t("deals.unit")}</th>
                                        <th>{t("deals.resource")}</th>
                                        <th>{t("deals.price")}</th>
                                        <th>{t("deals.delete")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {editDeal["priceList"] != undefined ? editDeal["priceList"].map((i, key) => 
                                        <tr key={key}>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.resource_type")}
                                                    value={{value: i["resourceType"], label: i["resourceType"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeEditResourceType(val, key)
                                                    }}
                                                    options={{
                                                        choosetext: t("deals.resource_type_choosetext"),
                                                        choices: allResourceTypes!= undefined ? allResourceTypes.map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.resource_subtype")}
                                                    value={{value: i["resourceSubtype"], label: i["resourceSubtypes"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeEditResourceSubtype(val, key)
                                                    }}
                                                    options={{
                                                        choosetext: t("deals.resource_subtype_choosetext"),
                                                        choices: allResourceTypes!= undefined ? ((allResourceTypes.find(i => i["_id"] == editDeal["priceList"][key]["resourceType"]) || {})["resourceSubtype"] || []).map(i => { return { label: i, value: i } }) : [] 
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.unit")}
                                                    value={{value: i["unit"], label: i["unit"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeEditUnit(val, key)
                                                    }}
                                                    options={{
                                                    choosetext: t("deals.unit_choosetext"),
                                                        choices: [
                                                            { label: "day", value: "day" },
                                                            { label: "week", value: "week" },
                                                            { label: "month", value: "month" },
                                                            { label: "hour", value: "hour" },
                                                            { label: "once", value: "once" }
                                                        ]
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="select"
                                                    //title={t("deals.resrouce")}
                                                    value={{value: i["resource"], label: i["resource"]}}
                                                    onChange={(val) => {
                                                        handleOnChangeEditResource(val, key)
                                                    }}
                                                    options={{
                                                        choosetext: t("deals.resource_choosetext"),
                                                        choices: allResources!= undefined ? (allResources.filter(i => i["resourceSubtype"] == editDeal["priceList"][key]["resourceSubtype"])).map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <Field
                                                    type="input"
                                                    //title={t("deals.price")}
                                                    value={i["price"]}
                                                    onChange={(val) => {
                                                        setEditPrice(val, key)
                                                    }}
                                                ></Field>
                                            </td>
                                            <td>
                                                <InputGroup.Append>
                                                    <Button onClick={(evt) => deleteEditPriceList(key)}>{t("deals.pricelist_delete")}</Button>
                                                </InputGroup.Append>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            <Button onClick={addEditPriceList}>{t("deals.pricelist_add")}</Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setShowEditModal(false)}>
                            {t("deals.cancel")}
                        </Button>
                        <Button onClick={handleEditDeal}>
                            {t("deals.save")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("deals.delete")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("deals.delete_info")}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setShowDeleteModal(false)}>
                            {t("deals.cancel")}
                        </Button>
                        <Button onClick={handleDeleteDeal}>
                            {t("deals.delete")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showChangeDefaultModal} onHide={() => setShowChangeDefaultModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("deals.change_default")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("deals.change_default_info")}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setShowChangeDefaultModal(false)}>
                            {t("deals.cancel")}
                        </Button>
                        <Button onClick={() => handleChangeDefaultDeal()}>
                            {t("deals.confirm")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
}

export default Deals;